import { geoViewColors } from '@/ui/style/default';
import type { IGeoViewColors } from '@/ui/style/types';

export const geoCaThemeColors: IGeoViewColors = {
  ...geoViewColors,
};
